export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20lifestyle%20photography%20of%20a%20thoughtfully%20styled%20entryway%20console%20table%20with%20neatly%20arranged%20fashion%20pieces%20including%20a%20folded%20knit%20sweater%20leather%20sneakers%20and%20a%20canvas%20tote%20bag%20beside%20a%20ceramic%20vase%20with%20fresh%20eucalyptus%20stems%20gentle%20golden%20hour%20sunlight%20streaming%20through%20adjacent%20window%20casting%20long%20soft%20shadows%20across%20the%20scene%20cozy%20aspirational%20home%20aesthetic%20with%20organic%20textures%20and%20serene%20welcoming%20atmosphere&width=1920&height=1080&seq=pandabuy-cta-section-v3&orientation=landscape"
          alt="Pandabuy Spreadsheet Hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white tracking-wide">
          ENTER FULL SPREADSHEET HUB
        </h2>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/80 leading-relaxed max-w-xl mx-auto">
          Join thousands of buyers using
          <br />
          our curated Pandabuy index
        </p>

        {/* CTA Button */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 md:mt-10 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-all duration-200 cursor-pointer group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500">
            <i className="ri-shopping-bag-3-line text-white text-sm"></i>
          </span>
          <span className="text-sm font-bold tracking-wide">BUY IT NOW</span>
          <i className="ri-arrow-right-up-line text-white text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}